import type { ReactNode } from 'react';

interface SitePageHeroProps {
  tag: string;
  title: string;
  subtitle: ReactNode;
}

export function SitePageHero({ tag, title, subtitle }: SitePageHeroProps) {
  return (
    <section className="utility-hero">
      <div className="container">
        <div className="utility-hero-wrap">
          <div className="utility-hero-text-wrap">
            <div className="tag">{tag}</div>
            <div className="heading-wrap">
              <h1>{title}</h1>
            </div>
            <div className="utility-subtitle-wrap small">
              <div className="paragraph-02 text-dark-grey contact-subtitle">{subtitle}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
